import { createFileRoute } from '@tanstack/react-router';
import { AdminQuoteReviewPage } from '@/features/admin/admin-quote-review-page';

export const Route = createFileRoute('/admin/quotes/$id/')({
  component: AdminQuoteReviewRoute,
});

function AdminQuoteReviewRoute() {
  const { id } = Route.useParams();
  return <AdminQuoteReviewPage quoteId={id} />;
}
